/**
 * @fileoverview The build's commit SHA, carried by `index.html`.
 *
 * The SHA is written into the page by `vite/buildCommitMetaPlugin.ts` rather
 * than substituted into the JS bundle. Substituting it changed the content —
 * and so the filename — of the entry chunk on every build, and with it every
 * chunk that imports the entry, so each release renamed most chunks even when
 * no front-end code had changed and stranded every open tab
 * ([#4503](https://github.com/CodeinPlace/cip/issues/4503)). `index.html` is
 * not content-hashed, so a new SHA there renames nothing.
 *
 * This module must stay free of browser-only imports: the Vite configs import
 * it at build time.
 */

/** `name` attribute of the `<meta>` element that carries the build's SHA. */
export const BUILD_COMMIT_META_NAME = 'cip-build-commit';

/**
 * Reads the build's commit SHA from the page.
 *
 * @returns The SHA stamped into `index.html`, or `'unknown'` where there is
 *   no document (a worker) or no stamp (tests, a page served without the
 *   plugin).
 * @throws Never.
 */
export function readBuildCommit(): string {
  if (typeof document === 'undefined') {
    return 'unknown';
  }
  return (
    document
      .querySelector(`meta[name="${BUILD_COMMIT_META_NAME}"]`)
      ?.getAttribute('content') || 'unknown'
  );
}
